import { inject, Injectable } from '@angular/core';
import { HelperTimeService } from '@common/services/helper-time.service';
import { EventNeoBuild, FichaSettings } from '@fichaje/interfaces/ficha-event.interface';
import { HelperService } from '@common/services/helper.service';
import { ControlState, TimeControl } from '@fichaje/interfaces/ficha-time-control.interface';

// DayJS dependency
import dayjs, { Dayjs } from 'dayjs/esm/index.js';
import localizedFormat from 'dayjs/esm/plugin/localizedFormat';
import utc from 'dayjs/esm/plugin/utc';
import timezone from 'dayjs/esm/plugin/timezone';
import isBetween from 'dayjs/esm/plugin/isBetween';
import weekOfYear from 'dayjs/esm/plugin/weekOfYear';
// import duration from 'dayjs/esm/plugin/duration'
dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isBetween);
dayjs.extend(isBetween);
dayjs.extend(weekOfYear);



@Injectable({
  providedIn: 'root'
})
export class FichaTimeControlService {

  private readonly helpTime = inject(HelperTimeService);
  private readonly helpData = inject(HelperService);
  // private readonly fichaService = inject(FichaService);


  setTimeControl(ev:EventNeoBuild, settings:FichaSettings):TimeControl{
    // CREA LOS puntos horarios que limitan la jornada.
    // if ( !(settings.whenIsIt === 'today') ) return {} //! VALIDAR PARA JORNADAS NOCTURNAS
    const tCtrl:TimeControl = {state: 'future'};
    const clockIn = dayjs(ev.event_start_clock_in);
    const capabilities = settings.capabilities;
    const notComputablesToAdd = this.notComputables(ev, settings);
    const clockOutExpectedComputed = clockIn.add((ev.working_hours_expected + notComputablesToAdd), 'minutes')
    //? falta agregar pausas extra y permisos
    if(ev.event_start_expected) {
      tCtrl.clockIn = {
        expected:         dayjs(ev.event_start_expected),
        allowAdjustment:  capabilities?.allow_event_start_limit_adjustment ??
                          false
      };
      tCtrl.clockIn.limit = ev.event_start_limit >= 0  ?
                                tCtrl.clockIn.expected.subtract(ev.event_start_limit, 'minutes') :
                                tCtrl.clockIn.expected.subtract(1439, 'minutes');
      tCtrl.clockIn.control = ev.event_start_control >= 0  ?
                                tCtrl.clockIn.expected.subtract(ev.event_start_control, 'minutes') :
                                tCtrl.clockIn.expected.subtract(1439, 'minutes');
      tCtrl.clockIn.tolerance = ev.event_start_tolerance >= 0  ?
                                tCtrl.clockIn.expected.add(ev.event_start_tolerance, 'minutes') :
                                tCtrl.clockIn.expected.add(1439, 'minutes');
    }
    if(ev.event_end_expected && ev.event_start_clock_in) {
      tCtrl.clockOut = {
        expected:         clockOutExpectedComputed, //dayjs(ev.event_end_expected),
        allowAdjustment:  capabilities?.allow_event_end_limit_adjustment ??
                          false
      };
      tCtrl.clockOut.clockedIn = clockIn;
      tCtrl.clockOut.clockedInPlusOne = clockIn.add( 1 , 'minutes' );
      tCtrl.clockOut.tolerance = ev.event_end_tolerance >= 0 ?
                                clockOutExpectedComputed.subtract(ev.event_end_tolerance, 'minutes') :
                                clockOutExpectedComputed.subtract(1439, 'minutes');
      tCtrl.clockOut.control = ev.event_end_control >= 0 ?
                                clockOutExpectedComputed.add(ev.event_end_control, 'minutes') :
                                clockOutExpectedComputed.add(1439, 'minutes');
      tCtrl.clockOut.limit = ev.event_end_limit >= 0 ?
                                clockOutExpectedComputed.add(ev.event_end_limit, 'minutes') :
                                clockOutExpectedComputed.add(1439, 'minutes');
    }
    if(ev.working_hours_expected && ev.event_start_clock_in) {

      const totalPausasSeconds = ev.meta_closed_pause ?
                                  this.helpData.totalizeArrayObjs(ev.meta_closed_pause, 'elapsed_seconds') :
                                  0;
      const totalPermisosSeconds = ev.meta_closed_leaves ?
                                  this.helpData.totalizeArrayObjs(ev.meta_closed_leaves, 'elapsed_minutes')*60 :
                                  0;
      const expectedSeconds = ev.working_hours_expected*60 + (ev.lunch ?? 0)*60 + totalPausasSeconds + totalPermisosSeconds
      const exitTimeExpected = dayjs( clockIn.add(expectedSeconds, 'seconds') );

      tCtrl.workingHours = { expected: exitTimeExpected };
      tCtrl.workingHours.tolerance = ev.working_hours_tolerance ?
                                tCtrl.workingHours.expected.subtract(ev.working_hours_tolerance, 'minutes') :
                                undefined;
    }

    if (ev.event_start_clock_in && !ev.event_end_clock_out ){
      // console.log('Current TimeControl:', tCtrl)
    }
    return tCtrl
  }
  private notComputables(ev:EventNeoBuild, settings:FichaSettings):number{
    if(!ev.event_start_clock_in) return 0

    let minutesLunchAdded = 0;
    let pausas = 0
    //! agregar calculo de pausas
    // si el usuario tiene u



    // tiempo de comida agrega al ajoranda?
    //2026-03-02 08:02:00.000

    const start = new Date(ev.event_start_clock_in).getTime()
    const now = new Date().getTime()
    const minutosTrabajados = ( now - start) / 60000
    // console.log ('minutosTrabajados - start', minutosTrabajados)
    // if (minutosTrabajados > settings.userLogged.limite_comida && ev.lunch){
    //   minutesLunchAdded = ev.lunch
    // }
    if (ev.lunch){
      minutesLunchAdded = ev.lunch
    }
    return minutesLunchAdded
  }

  private eventFree(){ //! Pendiente ver si es necesario agregar un else cuando no exista control de tiempo... evento libre
    const timeControl = {
      clockIn: {
          allowAdjustment:   true,
          limit:             dayjs( new Date() ).subtract(1, 'day'),
          control:           dayjs( new Date() ).subtract(1, 'day'),
          expected:          dayjs( new Date() ),
          tolerance:         dayjs( new Date() ).add(1, 'day'),
          clockedIn:         dayjs( new Date() ),
          clockedInPlusOne:  dayjs( new Date() ),
      }
      // clockOut:      TimeControlEvent;
      // workingHours:  TimeControlWorkingHours;
    }
  }

}
